import api from './api';

export interface InvitationLetter {
  id?: number;
  user_id?: number;
  title: string;
  content: string;
  created_at?: string;
  updated_at?: string;
}

export const invitationLetterService = {
  // Get all invitation letters for the current user
  async getAll(): Promise<InvitationLetter[]> {
    const response = await api.get('/invitation-letters');
    return response.data.data;
  },

  // Get a specific invitation letter by ID
  async getById(id: number): Promise<InvitationLetter> {
    const response = await api.get(`/invitation-letters/${id}`);
    return response.data.data;
  },

  // Create a new invitation letter
  async create(data: Omit<InvitationLetter, 'id' | 'user_id' | 'created_at' | 'updated_at'>): Promise<InvitationLetter> {
    const response = await api.post('/invitation-letters', data);
    return response.data.data;
  },

  // Update an existing invitation letter
  async update(id: number, data: Partial<InvitationLetter>): Promise<InvitationLetter> {
    const response = await api.put(`/invitation-letters/${id}`, data);
    return response.data.data;
  },

  // Delete an invitation letter
  async delete(id: number): Promise<void> {
    await api.delete(`/invitation-letters/${id}`);
  }
};

